export function arrows($name, $autoPlayOption = false) {
    if (!$($name).length) {
        return;
    }

    $($name).slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: $autoPlayOption,
        variableWidth: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        swipe: true,
        swipeToSlide: true,
        pauseOnHover: false,
        autoplaySpeed: 12000,
        prevArrow: '<button type="button" name="Previouse" title="Previouse" value="Previouse" class="slick-prev"><i class="icon icon-arrow_left"></i></button>',
        nextArrow: '<button type="button" name="Next" title="Next" value="Next" class="slick-next"><i class="icon icon-arrow_right"></i></button>'
    });
}

export function arrowsAndDots($name) {
    if (!$($name).length) {
        return;
    }

    $($name).slick({
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: false,
        variableWidth: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        swipe: true,
        swipeToSlide: true,
        pauseOnHover: false,
        autoplaySpeed: 12000,
        prevArrow: '<button type="button" name="Previouse" title="Previouse" value="Previouse" class="slick-prev"><i class="icon icon-arrow_left"></i></button>',
        nextArrow: '<button type="button" name="Next" title="Next" value="Next" class="slick-next"><i class="icon icon-arrow_right"></i></button>'
    });
}

export function integrationSlider($name) {
    const $sec = $name + '-sec';

    if (!$($name).length || !$($sec).length) {
        return;
    }

    let options = {
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        variableWidth: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        swipe: true,
        swipeToSlide: true,
        asNavFor: $sec,
        pauseOnHover: false,
        autoplaySpeed: 10000
    };

    if ($(window).width() < 768) {
        options.appendDots = $($name + '-parent');
    }

    $($name).slick(options);

    $($sec).slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: false,
        variableWidth: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        swipe: true,
        swipeToSlide: true,
        asNavFor: $name,
        pauseOnHover: false,
        prevArrow: '<button type="button" name="Previouse" title="Previouse" value="Previouse" class="slick-prev"><i class="icon icon-arrow_left"></i></button>',
        nextArrow: '<button type="button" name="Next" title="Next" value="Next" class="slick-next"><i class="icon icon-arrow_right"></i></button>',
        appendArrows: $($name + '-parent'),
        autoplaySpeed: 10000
    });
}

export function clients($name) {
    if (!$($name).length) {
        return;
    }

    $($name).slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        variableWidth: false,
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        fade: false,
        swipe: true,
        swipeToSlide: true,
        pauseOnHover: true,
        autoplaySpeed: 1000,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 350,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 419,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 619,
                settings: {
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 819,
                settings: {
                    slidesToShow: 7
                }
            },
            {
                breakpoint: 1119,
                settings: {
                    slidesToShow: 8
                }
            },
            {
                breakpoint: 1319,
                settings: {
                    slidesToShow: 9
                }
            },
            {
                breakpoint: 1519,
                settings: {
                    slidesToShow: 10
                }
            },
            {
                breakpoint: 1719,
                settings: {
                    slidesToShow: 11
                }
            },
            {
                breakpoint: 1919,
                settings: {
                    slidesToShow: 12
                }
            },
            {
                breakpoint: 2119,
                settings: {
                    slidesToShow: 13
                }
            },
            {
                breakpoint: 2319,
                settings: {
                    slidesToShow: 14
                }
            },
            {
                breakpoint: 2519,
                settings: {
                    slidesToShow: 15
                }
            },
            {
                breakpoint: 2719,
                settings: {
                    slidesToShow: 16
                }
            },
            {
                breakpoint: 2919,
                settings: {
                    slidesToShow: 17
                }
            },
            {
                breakpoint: 3119,
                settings: {
                    slidesToShow: 18
                }
            },
            {
                breakpoint: 3319,
                settings: {
                    slidesToShow: 19
                }
            },
            {
                breakpoint: 3519,
                settings: {
                    slidesToShow: 20
                }
            }
        ],
    });
}
